type GoogleFontLoaderProps = { fontName: string };
export const GoogleFontLoader = ({ fontName }: GoogleFontLoaderProps) => {
    const url = `https://fonts.googleapis.com/css2?family=${fontName}:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap`;

    return <link rel="stylesheet" href={url} />;
};
